import { useEffect } from 'react';
import { useArchitectureStore } from '../store/useArchitectureStore';
import { useDiagramViewStore } from '../store/useDiagramViewStore';

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable;
}

export function useArchitectureKeyboardShortcuts() {
  useEffect(() => {
    function handler(e: KeyboardEvent) {
      const mod = e.metaKey || e.ctrlKey;
      const store = useArchitectureStore.getState();

      if (useDiagramViewStore.getState().readOnly && (mod || e.key === 'Delete' || e.key === 'Backspace')) {
        if (mod && e.key.toLowerCase() === 's') e.preventDefault();
        return;
      }

      if (mod && e.key.toLowerCase() === 's') {
        e.preventDefault();
        store.save();
        return;
      }
      if (mod && !e.shiftKey && e.key.toLowerCase() === 'z') {
        e.preventDefault();
        store.undo();
        return;
      }
      if ((mod && e.shiftKey && e.key.toLowerCase() === 'z') || (mod && e.key.toLowerCase() === 'y')) {
        e.preventDefault();
        store.redo();
        return;
      }

      if (isTypingTarget(document.activeElement) || mod) return;

      if (e.key.toLowerCase() === 'f') {
        e.preventDefault();
        useDiagramViewStore.getState().instance?.fitView({ duration: 300 });
      } else if (e.key === 'Delete' || e.key === 'Backspace') {
        const multi = useDiagramViewStore.getState().multiSelectedIds;
        if (multi.length > 1) {
          e.preventDefault();
          store.deleteNodes(multi);
          useDiagramViewStore.getState().setMultiSelectedIds([]);
          return;
        }
        const sel = store.selection;
        if (!sel) return;
        e.preventDefault();
        if (sel.type === 'node') store.deleteNode(sel.id);
        else if (sel.type === 'edge') store.deleteEdge(sel.id);
      }
    }

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);
}
